import { useCallback } from 'react';

import { Typography, TableRow, TableCell, MarketingContentPreview } from '@occc-app/design-system';
import { statusBadge } from '@occc-app/lib/publicationStatusBadge';
import { GamesListItemFragment } from '@occc/graphql';

import { GameActionsContainer } from './GameActionsContainer';

type GameTableRowProps = {
  offer: GamesListItemFragment;
  areActionsVisible: boolean;
  onItemClick: (id: string) => void;
};

export const GameTableRow = ({ offer, areActionsVisible, onItemClick }: GameTableRowProps) => {
  const { id, name, marketingContents, deleted, fulfillmentCount, publicationStatus } = offer;

  const handleItemClick = useCallback(() => {
    onItemClick(id);
  }, [id, onItemClick]);

  return (
    <TableRow onClick={handleItemClick}>
      <TableCell>
        <Typography>{name}</Typography>
      </TableCell>
      <TableCell>
        <MarketingContentPreview
          title={marketingContents?.[0]?.title || 'No Name Provided'}
          description={marketingContents?.[0]?.shortDescription || 'No Description Provided'}
          imageUrl={marketingContents?.[0]?.imageUrl ?? undefined}
        />
      </TableCell>
      <TableCell>{statusBadge(deleted, publicationStatus)}</TableCell>
      <TableCell align='center'>{fulfillmentCount}</TableCell>
      {areActionsVisible && (
        <TableCell padding='button' align='right'>
          <GameActionsContainer id={id} name={name} deleted={deleted} />
        </TableCell>
      )}
    </TableRow>
  );
};
